<template>
  <OfficeDetail />
</template>

<script>
import OfficeDetail from "@/components/office/OfficeDetail";

export default {
  name: 'OfficeView',
  components: {OfficeDetail},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
